import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { Organisation } from 'src/app/interfaces/organisation';
import { OrganisationService } from 'src/app/services/organisation.service';
import { SeoService } from 'src/app/services/seo.service';
import { organisationPageSlug } from 'src/app/utils/organisation-page-url';
import { applyOrganisationPageSeo } from './organisation-page-seo.util';

/** Loads public organisation metadata by GUID or name slug. */
export const organisationPageResolver: ResolveFn<Organisation | null> = (route) => {
  const router = inject(Router);
  const rawId = route.paramMap.get('id')?.trim() ?? '';
  const slugKey = organisationPageSlug(rawId);
  if (!rawId || !slugKey) {
    return new RedirectCommand(router.parseUrl('/marketplace'));
  }

  const organisationService = inject(OrganisationService);
  const seoService = inject(SeoService);

  return organisationService.getByIdPublic(rawId).pipe(
    map((org) => {
      if (!org) {
        throw new Error(`Organisation ${rawId} not found`);
      }
      applyOrganisationPageSeo(seoService, org as Organisation);
      return org as Organisation;
    }),
    catchError(() => of(null)),
  );
};
